<h2 mat-dialog-title>
  <mat-icon class="title-icon">sync</mat-icon>
  {{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.TITLE' | translate: { name: data.templateName || '' } }}
</h2>
<mat-dialog-content class="dialog-container">
  <div class="app-container">
    @if (loading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="text-faint">{{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.COMPARING' | translate }}</p>
    } @else if (loadError(); as key) {
      <p>{{ key | translate }}</p>
    } @else if (preview(); as p) {
      <p class="text-faint">
        @if (data.projectName) {
          {{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.SITE' | translate: { name: data.projectName } }} ·
        }
        {{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.NOTHING_DELETED' | translate }}
      </p>

      @if (nothingToDo()) {
        <p>{{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.IN_SYNC' | translate }}</p>
      } @else {
        @if (p.additions.length > 0) {
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.ADDITIONS' | translate: { count: p.additions.length } }}</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-checkbox [checked]="allAdditionsSelected()" [indeterminate]="state().add.size > 0 && !allAdditionsSelected()" (change)="onToggleAllAdditions($event.checked)">
              {{ 'WORKCLASSIFICATION.TEMPLATES.LINK.SELECT_ALL' | translate }}
            </mat-checkbox>
            <div class="check-list">
              @for (a of p.additions; track a.templateNodeId) {
                <mat-checkbox [checked]="isAdd(a.templateNodeId)" (change)="onToggleAddition(a.templateNodeId, $event.checked)">
                  {{ a.path }}
                  @if (a.parentWillBeAdded) {
                    <span class="text-faint"> ({{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.PARENT_ADDED' | translate }})</span>
                  }
                </mat-checkbox>
              }
            </div>
          </mat-expansion-panel>
        }

        @if (p.renames.length > 0) {
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.RENAMES' | translate: { count: p.renames.length } }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="check-list">
              @for (r of p.renames; track r.projectNodeId) {
                <div class="rename-row" [class.billed]="r.billedEntryCount > 0">
                  <mat-checkbox [checked]="isRename(r.projectNodeId)" (change)="onToggleRename(r.projectNodeId, $event.checked)">
                    {{ r.currentName }} → {{ r.newName }}
                    <span class="text-faint"> · {{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.ENTRY_COUNTS' | translate: { entries: r.entryCount, billed: r.billedEntryCount } }}</span>
                  </mat-checkbox>
                  @if (r.billedEntryCount > 0) {
                    <p class="billed-warning">
                      <mat-icon class="info-icon">warning</mat-icon>
                      {{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.BILLED_WARNING' | translate }}
                    </p>
                  }
                </div>
              }
            </div>
          </mat-expansion-panel>
        }

        @if (p.deletedInProject.length > 0) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.DELETED' | translate: { count: p.deletedInProject.length } }}</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="check-list">
              @for (d of p.deletedInProject; track d.templateNodeId) {
                <mat-checkbox [checked]="isDeleted(d.templateNodeId)" (change)="onToggleDeleted(d.templateNodeId, $event.checked)">{{ d.path }}</mat-checkbox>
              }
            </div>
          </mat-expansion-panel>
        }
      }

      @if (p.linkInstead.length > 0 || countOf(p.projectOnlyNodes) > 0 || countOf(p.orphanedLinks) > 0) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.NOT_UPDATABLE' | translate: { count: p.linkInstead.length + countOf(p.projectOnlyNodes) + countOf(p.orphanedLinks) } }}</mat-panel-title>
          </mat-expansion-panel-header>
          <ul class="path-list">
            @for (l of p.linkInstead; track l.templateNodeId) {
              <li>{{ l.path }} — {{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.LINK_INSTEAD' | translate }}</li>
            }
            <li>{{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.PROJECT_ONLY' | translate: { count: countOf(p.projectOnlyNodes) } }}</li>
            <li>{{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.ORPHANED' | translate: { count: countOf(p.orphanedLinks) } }}</li>
          </ul>
        </mat-expansion-panel>
      }

      @if (billedCount() > 0) {
        <div class="confirm-billed" [class.confirm-error]="confirmError()">
          <mat-checkbox [checked]="state().confirmBilled" (change)="onConfirmBilled($event.checked)">
            {{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.CONFIRM_BILLED' | translate: { count: billedCount() } }}
          </mat-checkbox>
          @if (confirmError()) {
            <p class="billed-warning">{{ 'WORKCLASSIFICATION.TEMPLATES.ERROR.BILLED_RENAME_NOT_CONFIRMED' | translate }}</p>
          }
        </div>
      }
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (nothingToDo() || loadError()) {
    <button mat-raised-button class="btn-primary" mat-dialog-close>{{ 'COMMON.CLOSE' | translate }}</button>
  } @else {
    <button mat-button class="btn-secondary" mat-dialog-close>{{ 'COMMON.CANCEL' | translate }}</button>
    <button mat-raised-button class="btn-primary" (click)="apply()" [disabled]="!canSubmit()">
      {{ 'WORKCLASSIFICATION.TEMPLATES.SYNC.CONFIRM' | translate: { added: addCount(), renamed: renameCount() } }}
    </button>
  }
</mat-dialog-actions>
